// Project-phase dot colours for pickers. Lives in lib/ so TaskSheet can use
// it without a TaskRow <-> TaskSheet import cycle; TaskRow re-exports it.

import type { ProjectPhase } from '../../shared/types';

export const PHASE_DOTS: Record<ProjectPhase, string> = {
  'lead': 'var(--text-faint)',
  'pre-production': 'var(--accent-deep)',
  'shoot': 'var(--gold)',
  'post': 'var(--accent)',
  'delivered': 'var(--ok)',
  // Half-filled green: finished for the client, not yet for the studio.
  'clean_up': 'linear-gradient(90deg, var(--ok) 50%, color-mix(in srgb, var(--ok) 22%, transparent) 50%)',
  'closed': 'var(--text-faint)',
  'on_hold': 'var(--text-faint)',
};
